// extracted by mini-css-extract-plugin
module.exports = {"title":"TravelHighlightsList_title___5Z9U","list":"TravelHighlightsList_list__39ELU"};